import { Input, Modal, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseUrl } from "../../../../components/common/baseUrl";
import { useNotify } from "../../../../components/Notification";
import { settings } from "../../../../utils/config";
import { semantic } from "../../../../theme/tokens";

const PermissionForm = (props) => {
  const {
    isOpen,
    onOk,
    onCancel,
    hookForm,
    title = "Thêm permission",
    okText = "Lưu",
  } = props;
  const hasAccessToken = settings?.getCookie("access_token");
  const notify = useNotify();

  const [listParent, setListParent] = useState([]);
  const parentOptions = Array.isArray(listParent) ? listParent : [];

  const fetchActions = async () => {
    try {
      const url = `${baseUrl}/api/v1/security/permissions/permission-parent`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hasAccessToken}`,
        },
      });

      if (response.data.success && response.data.data) {
        const result = response.data.data;
        setListParent(
          Array.isArray(result)
            ? result.map((item) => ({ label: item.label, value: item.id }))
            : []
        );
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error.response?.data?.message,
      });
    }
  };

  useEffect(() => {
    fetchActions();
  }, []);

  return (
    <Modal
      title={title}
      closable={{ "aria-label": "Đóng" }}
      open={isOpen}
      onOk={hookForm?.handleSubmit(onOk)}
      onCancel={onCancel}
      okText={okText}
      cancelText="Hủy"
      width={640}
      destroyOnClose
    >
      <div style={{ display: "grid", gap: 16 }}>
        <div>
          <label style={{ marginBottom: 8, display: "block", fontWeight: 600 }}>
            Mã permission <span style={{ color: semantic.danger }}>*</span>
          </label>
          <Controller
            name="name"
            control={hookForm.control}
            rules={{ required: "Mã permission không được bỏ trống" }}
            render={({ field }) => (
              <Input {...field} placeholder="Ví dụ: menu.create" />
            )}
          />
          {hookForm?.formState?.errors?.name && (
            <span style={{ color: semantic.danger, fontSize: 12 }}>
              {hookForm.formState.errors.name.message}
            </span>
          )}
        </div>

        <div>
          <label style={{ marginBottom: 8, display: "block", fontWeight: 600 }}>
            Permission cha
          </label>
          <Controller
            name="parent_id"
            control={hookForm.control}
            render={({ field }) => (
              <Select
                {...field}
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Chọn nhóm quyền cha nếu có"
                optionFilterProp="label"
                options={parentOptions}
              />
            )}
          />
        </div>

        <div>
          <label style={{ marginBottom: 8, display: "block", fontWeight: 600 }}>
            Mô tả <span style={{ color: semantic.danger }}>*</span>
          </label>
          <Controller
            name="label"
            control={hookForm.control}
            rules={{ required: "Mô tả không được bỏ trống" }}
            render={({ field }) => (
              <TextArea
                {...field}
                placeholder="Mô tả ngắn gọn quyền này dùng để làm gì"
                autoSize={{ minRows: 3, maxRows: 5 }}
              />
            )}
          />
          {hookForm?.formState?.errors?.label && (
            <span style={{ color: semantic.danger, fontSize: 12 }}>
              {hookForm.formState.errors.label.message}
            </span>
          )}
        </div>
      </div>
    </Modal>
  );
};
export default PermissionForm;